import { ProgramEnvironment } from "../types/program";

export const ProgramEnvironmentToNameMap: Record<ProgramEnvironment, string> = {
  ONLINE: "Online",
  HYBRID: "Hybrid",
  IN_PERSON: "In person",
};

export const getSubmitCta = <
  Program extends {
    customCtaCopy?: string | null;
  },
>(
  program: Program | null
): string => {
  return program?.customCtaCopy ? program.customCtaCopy : "Agree & submit";
};

export const getNextCta = (): string => {
  return "Agree & next";
};

/**
 * A ZIP passes when the allowed list is empty or names it, and the excluded list
 * does not. Same rule as the DreamSearch SQL filter.
 */
export const isZipAllowedForProgram = (
  {
    allowedZipCodes,
    excludedZipCodes,
  }: {
    allowedZipCodes?: readonly string[] | null;
    excludedZipCodes?: readonly string[] | null;
  },
  zip: string
): boolean => {
  const zip5 = zip.trim().slice(0, 5);
  return (
    (!allowedZipCodes?.length || allowedZipCodes.includes(zip5)) &&
    !excludedZipCodes?.includes(zip5)
  );
};

/** Splits pasted ZIP codes on commas, spaces or new lines, dropping blanks and repeats. */
export const parseZipCodeList = (text: string): string[] => [
  ...new Set(text.split(/[\s,]+/).filter(Boolean)),
];
